import React from 'react';
import s from '../../Components/TableCommonDirectory/TableElements/TableElements.module.css';
import {UserInRegListType} from '../../types/TypesUserProfit';
import {statusUserInRegList} from '../../assets/utils/translatersFunc';
import TableRegistrationActions from './components/TableRegistrationActions';

type Props = {
	user: UserInRegListType;
	gridTemplateColumns: string;
};

const TableRegistrationListRowEl: React.FC<Props> = ({user, gridTemplateColumns}) => {
	return (
		<div 
			className={s.productRowContainer}
			style={{gridTemplateColumns}}
		>
			<div className={s.productRowcolumn}>{user.registration_date ? user.registration_date.slice(0, 10) : ''}</div>
			<div className={s.productRowcolumn}>{user.activity_date ? user.activity_date.slice(0, 10) : ''}</div>
			<div className={s.productRowcolumn}>{user.contract || '-'}</div>
			<div className={s.productRowcolumn}>{user.name || '-'}</div>
			<div className={s.productRowcolumn}>
				{user.status ? statusUserInRegList(user.status) : '-'}
			</div>
			<div className={s.productRowcolumn}>{user.parent_name || '-'}</div>
			<div className={s.productRowcolumn}>
				<TableRegistrationActions user={user} />
			</div>
		</div>
	);
};

export default TableRegistrationListRowEl;

